'use client';

import NextLink from '@/components/next-link';
import FooterTitle from './FooterTitle';
import Image from '@/components/image';
import { sortJSONKeys } from '@/utils/global';
import { event_button_click } from '@/utils/gtm';

const SOCIAL_NAMES = {
  'wa.me': 'WhatsApp',
  'whatsapp.com': 'WhatsApp',
  'facebook.com': 'Facebook',
  'instagram.com': 'Instagram',
  'twitter.com': 'X',
  'x.com': 'X',
  'snapchat.com': 'Snapchat',
  'youtube.com': 'YouTube',
  'tiktok.com': 'TikTok',
  'linkedin.com': 'LinkedIn',
};

const getSocialName = (url = '') => {
  const host = (url.split('/')[2] || '').replace(/^www\./, '').toLowerCase();
  return SOCIAL_NAMES[host] || host || 'Social';
};

const SocialLinks = ({ socialLinksData, isMobile }) => {
  return (
    <div className='text-primary'>
      <FooterTitle title={'Follow Innova'} className={'max-lg:hidden'} />

      <div className='mb-3.5 flex space-x-3 max-lg:justify-center lg:mb-7'>
        {sortJSONKeys(socialLinksData?.value || [], isMobile)?.map(
          (social, index) => (
            <NextLink
              href={social?.url}
              target={'_blank'}
              key={index}
              onClick={() =>
                event_button_click({
                  button_name: getSocialName(social?.url),
                  button_destination: social?.url,
                  button_location: 'footer',
                })
              }
              className='flex h-[36px] w-[38px] items-center justify-center rounded-lg border border-solid border-[#1f2b7b] transition-all hover:translate-y-[-2px] hover:opacity-75 sm:size-10.5 md:size-11.5 lg:h-[50px] lg:w-[52px]'
            >
              <Image
                src={social?.icon}
                alt={social?.url + 'icon'}
                width={45}
                height={45}
                className='size-[17px]'
              />
            </NextLink>
          )
        )}
      </div>
    </div>
  );
};

export default SocialLinks;
